/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Config } from './config-tokens';

export type ConfigFactory = (...props: any[]) => Config;
